import { TranslatedText } from '../../../../types'
import { ReactNode } from 'react'

export const STEPPED_MODAL_STORAGE_KEY = 'stopen-stepped-modal-seen'

export interface ModalStep {
    title: TranslatedText
    description: ReactNode
    image?: ReactNode
}

export const STEPPED_MODAL_MESSAGE_KEYS = {
    STEP_INDICATOR: 'STO.STEPPED_MODAL.STEP_INDICATOR',
    BUTTON_PREVIOUS: 'STO.STEPPED_MODAL.BUTTONS.PREVIOUS',
    BUTTON_NEXT: 'STO.STEPPED_MODAL.BUTTONS.NEXT',
    BUTTON_DONE: 'STO.STEPPED_MODAL.BUTTONS.DONE',
}
